import { render, staticRenderFns } from "./RsaAdiProtocolliRiepologoListComponent.vue?vue&type=template&id=4b12d74c"
import script from "./RsaAdiProtocolliRiepologoListComponent.vue?vue&type=script&lang=js"
export * from "./RsaAdiProtocolliRiepologoListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaAdiProtocolliRiepologoListComponent.vue?vue&type=style&index=0&id=4b12d74c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports